import { useDispatch, useSelector } from "react-redux";
import { getDitaContent, selectDitaContent } from "../Content/ContentSlice";
import style from "./FAQContent.module.scss"
import classNames from "classnames";
import { useState, useRef, useEffect } from "react";
import useAppModernisation from "../../hooks/useAppModernisation";
import { useNavigate } from "react-router-dom";
import { createUrlFromDitaFilename } from "../../utils/formatters/createUrlFromDitaFilename";

const FAQSection = ({ topic }) => {
  const [collapsed, setCollapsed] = useState(true);
  const content = useSelector(selectDitaContent);
  const dispatch = useDispatch();
  const answerRef = useRef(null);
  const navigate = useNavigate();
  const { isMobileView } = useAppModernisation();

  const faqContents = getDitaContent("Changes/FAQs/" + topic.attributes.href.value, content, dispatch);
  let faqTitle = "";
  let faqAnswer = "";
  if (faqContents) {
    let titleElement = faqContents.getElementsByTagName("title")[0];
    if (!titleElement) {
      titleElement = faqContents.getElementsByTagName("ditatitle")[0];
    }
    
    if (titleElement && titleElement.textContent) {
      faqTitle = titleElement.textContent;
    }
    const conbody = faqContents.getElementsByTagName("conbody")[0];
    
    if (conbody) {
      faqAnswer = conbody.innerHTML;
    }
  }

  const collapse = () => {
    setCollapsed(!collapsed);
  };

  useEffect(() => {
    if (!answerRef.current || collapsed) return;

    const handleLinkClick = (e) => {
      e.preventDefault();
      
      let href = e.currentTarget.getAttribute('href');
      if (!href) return;

      if (href.startsWith('mailto:')) {
        window.location.href = href;
        return;
      }

      if (href.includes('.dita')) {
        href = createUrlFromDitaFilename(href);
      }

      if (!href.startsWith('http://') && !href.startsWith('https://')) {
        navigate(href);
      } else {
        window.open(href, '_blank', 'noopener,noreferrer');
      }
    };

    const container = answerRef.current;
    const xrefs = container.querySelectorAll('xref');
    
    xrefs.forEach((xref) => {
      xref.addEventListener('click', handleLinkClick);
    });

    return () => {
      xrefs.forEach((xref) => {
        xref.removeEventListener('click', handleLinkClick);
      });
    };
  }, [collapsed, faqAnswer, navigate]);

  return (
    <div
      className={classNames(
        isMobileView ? "size-16 medium" : "size-18 medium",
        style.question,
      )}
    >
      <div className={style.collapsibleRow} onClick={collapse}>
        <div>{faqTitle}</div>
        <i
          className={classNames(
            style.iconSize,
            collapsed ? " tg-icons-ChevronDown" : " tg-icons-ChevronUp",
          )}
        ></i>
      </div>
      {!collapsed && (
        <div
          ref={answerRef}
          className={classNames(
            isMobileView ? "size-14 medium" : "size-16 medium",
            style.answer,
          )}
          dangerouslySetInnerHTML={{ __html: faqAnswer }}
        ></div>
      )}
    </div>
  );
};

export default FAQSection;
